<v-app> 
  <v-main role="main">
    
    <router-view />
  </v-main>
</v-app>